const findUpdatePageIndex = (oldData: { pages: string | unknown[]; }, messageId: string) => {
  let pageIndex;
  if (!oldData?.pages || !messageId) {
    return pageIndex;
  }
  for (let i = 0; i < oldData?.pages?.length; i += 1) {
    const page = oldData.pages[i];
    let messageIndex = -1;
    if (Array.isArray(page)) {
      messageIndex = page.findIndex(
        (msg: { id: string; _id: string }) => msg?.id === messageId || msg._id === messageId,
      );
    }
    if (messageIndex !== -1) {
      pageIndex = i;
      break;
    }
  }
  return pageIndex;
};

export default findUpdatePageIndex;
